import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {httpCancelSiarExport} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'

export const useCancelSiarExport = (
    options?: Omit<UseMutationOptions<void, AxiosError, {id: string}>, 'mutationKey' | 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CANCEL_SIAR_EXPORT],
        mutationFn: ({id}) => httpCancelSiarExport({id}),
        onSettled: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_HISTORY]})
            options?.onSettled?.(...args)
        }
    })
}
